import { BOATS } from "../../data/boats";
import BoatCard from "../BoatCard";
import { Mail } from "lucide-react";
import { CONTACT } from "../../data/boats";

const available = BOATS.filter((b) => b.status === "available");
const comingSoon = BOATS.filter((b) => b.status === "coming_soon");

export default function BoatsSection() {
  return (
    <section id="boats" data-testid="boats-section" className="py-24 sm:py-32 bg-[#F5F3EE]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">

        {/* Section header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14 sm:mb-18">
          <div>
            <p className="eyebrow mb-4">Our Houseboats</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#1C1C1A] tracking-tight leading-tight">
              Book your stay<br />
              <em className="italic">on the water.</em>
            </h2>
          </div>
          <p className="text-[#6B6B65] leading-relaxed max-w-xs text-sm font-light sm:text-right">
            Moored at Inner Lakes Marina, Lough Ree — within walking distance of dinner.
          </p>
        </div>

        {/* Available boats grid */}
        <div className={`grid grid-cols-1 ${available.length > 1 ? "md:grid-cols-2" : "max-w-xl"} gap-x-12 gap-y-14`}>
          {available.map((boat) => (
            <BoatCard key={boat.slug} boat={boat} />
          ))}
        </div>

        {/* Coming soon strip */}
        {comingSoon.length > 0 && (
          <div className="mt-20 pt-12 border-t border-[#1C1C1A]/8">
            <p className="eyebrow mb-6">Coming Soon</p>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-8">
              <div>
                <h3 className="font-serif text-2xl sm:text-3xl font-light text-[#1C1C1A] tracking-tight">
                  {comingSoon[0].name} — <em className="italic">joining the fleet soon.</em>
                </h3>
                <p className="mt-3 text-sm text-[#6B6B65] font-light max-w-lg">
                  {comingSoon[0].short} Join the waitlist and be first to hear when bookings open.
                </p>
              </div>
              <a
                href={`mailto:${CONTACT.email}?subject=Waitlist%20—%20${encodeURIComponent(comingSoon[0].name)}`}
                className="btn-outline shrink-0 inline-flex items-center gap-2"
              >
                <Mail size={13} /> Join the waitlist
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
